const validations = {
  tenChar: 'Must not be longer than 10 characters',
  overTwenty: 'This number cannot be over 20',
}

export default validations
